import React from 'react';
import BacBlock1Hero from '../bac/BacBlock1Hero';
import BacBlock2Value from '../bac/BacBlock2Value';
import BacBlock3Engine from '../bac/BacBlock3Engine';
import BacBlock4Lines from '../bac/BacBlock4Lines';
import BacBlock5Core from '../bac/BacBlock5Core';
import BacBlock6Roles from '../bac/BacBlock6Roles';
import BacBlock7CTA from '../bac/BacBlock7CTA';

export default function BacPage() {
  return (
    <>
      <BacBlock1Hero />
      <BacBlock2Value />
      <BacBlock3Engine />
      <BacBlock4Lines />
      <BacBlock5Core />
      <BacBlock6Roles />
      <BacBlock7CTA />
    </>
  );
}
